import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  ProviderType,
} from "../../../../services/cloudchipr.api";

interface ThunkArgs {
  provider: ProviderType;
  accountId: string | null;
  resourceId: string;
}

export const getResourceDetailsSingleResourceDataThunk = createAsyncThunk(
  "resourceDetails/getResourceDetailsSingleResourceData",
  async ({ provider, resourceId, accountId }: ThunkArgs, { dispatch }) => {
    const {
      getUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResources,
    } = cloudChiprApi.endpoints;

    if (!accountId) {
      return;
    }

    try {
      return await dispatch(
        getUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResources.initiate(
          { provider, resourceId, accountId },
        ),
      ).unwrap();
    } catch (e) {
      console.error(e);
    }
  },
);
